import { createSelector } from 'reselect';
// feature driver-cards-v2
import { STORE_NAME } from './constants';
//////////////////////////////////////////////////

const selectDriverCardsV2Store = (state) => state[STORE_NAME];

export const makeSelectPageVisited = () => createSelector(
  selectDriverCardsV2Store,
  ({ pageVisited }) => pageVisited,
);

export const makeSelectPageDefaultsLoaded = () => createSelector(
  selectDriverCardsV2Store,
  ({ pageDefaultsLoaded }) => pageDefaultsLoaded,
);

export const makeSelectVisibleDays = () => createSelector(
  selectDriverCardsV2Store,
  ({ visibleDays }) => visibleDays,
);

export const makeSelectShowTeam = () => createSelector(
  selectDriverCardsV2Store,
  ({ showTeam }) => showTeam,
);

export const makeSelectAdvancedSearchRadius = () => createSelector(
  selectDriverCardsV2Store,
  ({ advancedSearchRadius }) => advancedSearchRadius,
);

export const makeSelectRequestDateRange = () => createSelector(
  selectDriverCardsV2Store,
  ({ requestDateRange }) => requestDateRange,
);

export const makeSelectSelectedResourceId = () => createSelector(
  selectDriverCardsV2Store,
  ({ selectedResourceId }) => selectedResourceId,
);

export const makeSelectEditSession = () => createSelector(
  selectDriverCardsV2Store,
  ({ editSession }) => editSession,
);

export const makeSelectResourceMode = () => createSelector(
  selectDriverCardsV2Store,
  ({ resourceMode }) => resourceMode,
);

export const makeSelectResourceFilter = () => createSelector(
  selectDriverCardsV2Store,
  ({ resourceFilter }) => resourceFilter,
);

export const makeSelectResourceGroupBy = () => createSelector(
  selectDriverCardsV2Store,
  ({ resourceGroupBy }) => resourceGroupBy,
);

export const makeSelectResourceSearch = () => createSelector(
  selectDriverCardsV2Store,
  ({ resourceSearch }) => resourceSearch,
);

export const makeSelectCustomerFilter = () => createSelector(
  selectDriverCardsV2Store,
  ({ customerFilter }) => customerFilter,
);

export const makeSelectLoadReferenceFilter = () => createSelector(
  selectDriverCardsV2Store,
  ({ loadReferenceFilter }) => loadReferenceFilter,
);

export const makeSelectUnassignedPanelOpen = () => createSelector(
  selectDriverCardsV2Store,
  ({ unassignedPanelOpen }) => unassignedPanelOpen,
);

export const makeSelectUnassignedLoads = () => createSelector(
  selectDriverCardsV2Store,
  ({ unassignedLoads }) => unassignedLoads,
);

export const makeSelectAssignedResources = () => createSelector(
  selectDriverCardsV2Store,
  ({ assignedResources }) => assignedResources,
);

export const makeSelectResourceGroupInfo = () => createSelector(
  selectDriverCardsV2Store,
  ({ resourceGroupInfo }) => resourceGroupInfo,
);

export const makeSelectResourceGrouping = () => createSelector(
  selectDriverCardsV2Store,
  ({ resourceGrouping }) => resourceGrouping,
);
